module.exports = __webpack_public_path__ + "img/dammsugare.563f2035.png";